import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { BaseStoreFacade } from '@city/data-access';
import { SeoPageState } from '@seo/data-access';
import { catchError, combineLatest, filter, map, Observable, of, switchMap, tap } from 'rxjs';
import { SeoPageService } from '../services';

export const seoPageResolver =
  (strapiPageLabel: string): ResolveFn<SeoPageState | null> =>
  (): Observable<SeoPageState | null> => {
    const baseStoreFacade = inject(BaseStoreFacade);
    const seoPageService = inject(SeoPageService);

    return baseStoreFacade.getActiveCode().pipe(
      tap((baseStoreCode) => seoPageService.loadPage(strapiPageLabel, baseStoreCode)),
      switchMap(() =>
        combineLatest({
          page: seoPageService.getPage(),
          baseStoreCode: baseStoreFacade.getActiveCode(),
          isLoaded: combineLatest({
            isLoading: seoPageService.isLoading(),
            isSuccess: seoPageService.isSuccess(),
            isError: seoPageService.isError(),
          }).pipe(map(({ isLoading, isSuccess, isError }) => !isLoading && (isSuccess || isError))),
        }),
      ),
      filter(({ isLoaded }) => isLoaded),
      map(({ page }) => page),
      catchError(() => of(null)),
    );
  };
